export default __webpack_public_path__ + "static/MOVECO_1-48e86068c345faf534617348026f914e.png";